import { useTranslation } from 'react-i18next';
import { TokenUsageOperationEntry, TokenUsageResponse } from 'features/usage/services/usage-service';
import { UsageViewModel } from 'features/usage/utils/build-usage-view-model';
import { UsageOverview } from './usage-overview';
import {
  UsageAgentTable,
  UsageDailySection,
  UsageModelTable,
  UsageOperationSection,
  UsageProviderSection,
  UsageUserTable,
} from './usage-tables';
import { UsageTokenBreakdown } from './usage-token-breakdown';

export function UsageDashboard({
  data,
  viewModel,
  operations,
  showUsers,
}: {
  data: TokenUsageResponse;
  viewModel: UsageViewModel;
  operations: TokenUsageOperationEntry[];
  showUsers: boolean;
}) {
  const { t } = useTranslation();

  return (
    <>
      <UsageOverview
        totals={data.totals}
        periodDays={viewModel.periodDays.length}
        activeDays={data.breakdowns?.daily?.length ?? 0}
      />
      <UsageDailySection days={viewModel.allDays} peakTokens={viewModel.peakTokens} />
      <UsageTokenBreakdown
        totals={data.totals}
        completionRatio={viewModel.completionRatio}
        promptShare={viewModel.promptShare}
        completionShare={viewModel.completionShare}
      />
      <div className="grid items-stretch gap-3 xl:grid-cols-2">
        <UsageOperationSection operations={operations} totalTokens={data.totals.total_tokens} />
        <UsageProviderSection providers={viewModel.byProvider} />
      </div>
      <UsageModelTable models={viewModel.orderedModels} totalTokens={data.totals.total_tokens} />
      <UsageAgentTable agents={viewModel.byAgent} totalTokens={data.totals.total_tokens} />
      {showUsers && <UsageUserTable users={viewModel.byUser} totalTokens={data.totals.total_tokens} />}
      <div className="border-t border-border pt-4 font-mono text-[11px] leading-6 text-muted-foreground">
        {t('FOOTER_INDEPENDENT_COUNTS')}
        <br />
        {t('FOOTER_DONUT_NOTE')}
        <br />
        {t('FOOTER_UNKNOWN_MODEL')}
      </div>
    </>
  );
}
